module.exports = __webpack_public_path__ + "static/img/bg-Client-03.62b660d6.png";